import { render, staticRenderFns } from "./PledgeStatus.vue?vue&type=template&id=79497f33&"
import script from "./PledgeStatus.vue?vue&type=script&lang=js&"
export * from "./PledgeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports